export const ACT_NOT_INIT = -1;
export const ACT_NOT_BEGIN = 0;
export const ACT_RUNNING = 1;
export const ACT_END = 2;




// WEBPACK FOOTER //
// ./src/constant/act_stat.js